import React from "react";
import ErrorHandler from "./../../components/ErrorHandler/ErrorHandler.component";

const CustomSelectDropdown = ({
  name,
  reference,
  children,
  label,
  errors,
  value,
  onChange,
  showRequiredIcon,
  extraLabel,
  disabled,
  defaultValue,
  className,
}) => {
  return (
    <div className="mb-4">
      <div className="form-group">
        <div className="d-flex align-items-center">
          <label className="form-label">{label}</label>
          {showRequiredIcon && <sup className="ml-1 crimson">*</sup>}
          {extraLabel && extraLabel.length && (
            <label className="form-label ml-2">
              <small className="crimson">{extraLabel}</small>
            </label>
          )}
        </div>
        <select
          className={`form-control ${className}`}
          name={name}
          ref={reference}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
        >
          {children}
        </select>
        <ErrorHandler errors={errors} />
      </div>
    </div>
  );
};

export default CustomSelectDropdown;
